import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';
import { Text } from '../../styled';

export const BoxBg = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  border-radius: 8px;
  background-color: ${th('colors.fountainBlue')};
  color: ${th('colors.white')};

  @media ${sizes.desktop} {
    border-radius: 16px;
  }
`;

export const HighlightedNumber = styled.div`
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
`;

export const Explanation = styled(Text)`
  margin: 4px 0;
`;
